'use client';
import React from 'react';
import SpecificationTab from './SpecificationTab';
import Image from 'next/image';
import { Box } from '@mui/material';
import cn from './style.module.scss';
type Props = {
  anchorId?: string;
};
export default function VillasLaunchSpecification(props: any) {
  const { t, anchorId } = props;
  return (
    <Box
      id={anchorId}
      className={cn.wildsLaunchSpecification}
      component="section"
      sx={{
        backgroundImage: `url(${props.specContentBackground.url})`,
      }}
    >
      <Box className={cn.tabContainerShapeTop}>
        <Image
          src={props.contentGraphicShapeTop.url}
          alt="Wilds Launch Specification - Content Graphic Shape Top"
          layout="responsive"
          width={600}
          height={400}
          style={{
            objectFit: 'cover',
          }}
        />
      </Box>
      <SpecificationTab
        t={t}
        tabThemeImageBackground={props.tabThemeImageBackground}
        specContentBackground={props.specContentBackground}
        specificationTheme={props.specificationTheme}
        specificationMobileTheme={props.specificationMobileTheme}
        specificationDataBackground={props.specificationDataBackground}
        contentGraphicShapeBottom={props.contentGraphicShapeBottom}
        contentGraphicShapeTop={props.contentGraphicShapeTop}
      />
      <Box className={cn.tabContainerShapeBottom}>
        <Image
          src={props.containerShapeGraphicsBottom.url}
          alt="Wilds Launch Specification - Container Shape Graphics Bottom"
          layout="responsive"
          width={600}
          height={400}
          style={{
            objectFit: 'cover',
          }}
        />
      </Box>
    </Box>
  );
}
